// src/components/shopping-tickets/ShoppingTicket.jsx
import './ShoppingTicket.css'
import React, { useEffect, useRef, useState } from "react";
import MahutiModal from "../mahuti-modal/MahutiModal";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedActivity } from "../../store/MahutiReducer";
import { useNavigate } from "react-router-dom";
import { PAGES, PREFIX_PATH } from '../../utils/GlobalParams';

export default function ShoppingTicket(props) {
    const [videoOpen, setVideoOpen] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const store = useSelector(store => store.reducer);
    const modalRef = useRef(null);
    const previousFocusRef = useRef(null);
    const modalContentRef = useRef(null);
    const iframeRef = useRef(null);

    const onClickPayHandle = (e, scrollLine) => {
        dispatch(setSelectedActivity(props));
        let lpPrefix = store.lpName ? `/${store.lpName}` : '';
        const navLink = `${PREFIX_PATH}${lpPrefix}/${PAGES.ACTIVITY_FLOW}/${props.URI_Indentifier__c}#${scrollLine}`;
        navigate(navLink);
    }

    const openVideoModal = () => {
        // Store the current active element before opening the modal
        previousFocusRef.current = document.activeElement;
        setVideoOpen(true);
    };

    const closeVideoModal = () => {
        setVideoOpen(false);
        // Return focus to the element that was focused before the modal opened
        if (previousFocusRef.current) {
            previousFocusRef.current.focus();
        }
    };

    // Handle escape key press to close the modal
    useEffect(() => {
        const handleEscape = (event) => {
            if (videoOpen && event.key === 'Escape') {
                closeVideoModal();
            }
        };

        if (videoOpen) {
            document.addEventListener('keydown', handleEscape);
            
            // Set tabindex for iframe
            if (iframeRef.current) {
                iframeRef.current.setAttribute('tabindex', '0');
            }
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [videoOpen]);

    // Create a custom component to implement our own focus trap if you don't want to use the library
    const CustomFocusTrap = ({ children, active }) => {
        const trapRef = useRef(null);
        
        useEffect(() => {
            if (!active || !trapRef.current) return;
            
            const focusableElements = trapRef.current.querySelectorAll(
                'button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])'
            );
            
            if (focusableElements.length === 0) return;
            
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            
            // Set initial focus to the close button
            const closeButton = trapRef.current.querySelector('.close-modal-button');
            if (closeButton) {
                setTimeout(() => closeButton.focus(), 50);
            } else {
                setTimeout(() => firstElement.focus(), 50);
            }
            
            const handleTabKey = (e) => {
                // Only execute if the trap is active and Tab key is pressed
                if (!active || e.key !== 'Tab') return;
                
                // If Shift + Tab
                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                } 
                // If just Tab
                else {
                    if (document.activeElement === lastElement) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                }
            };
            
            // Add focus event listener to document to prevent focus from leaving the trap
            const handleFocus = (e) => {
                if (active && trapRef.current && !trapRef.current.contains(e.target)) {
                    e.preventDefault();
                    e.stopPropagation();
                    firstElement.focus();
                }
            };
            
            document.addEventListener('keydown', handleTabKey);
            document.addEventListener('focusin', handleFocus);
            
            return () => {
                document.removeEventListener('keydown', handleTabKey);
                document.removeEventListener('focusin', handleFocus);
            };
        }, [active]);
        
        return <div ref={trapRef}>{children}</div>;
    };

    return <div className={"shoppingTicket card text-start p-3 h-100 border-0 "} >
        {props.isEditMode && <i className="icon-success-1" />}
        <div className="card-header py-1 px-0 border-0">
            <h3 className="card-title">{props.Title ? props.Title : '---'}</h3>
            <div className="card-subtitle"><span>{props.Subtitle ? props.Subtitle : '--'}</span></div>
        </div>

        {props.videoURL ? (
            <button
                className={`d-flex justify-content-center align-items-center w-100 border-0 bg-transparent`}
                onClick={openVideoModal}
                aria-label={`פתח סרטון על ${props.Title || 'הפעילות'}`}
            >
                <img 
                    className="bd-placeholder-img card-img-top rounded-0 py-1" 
                    width="100%"
                    src={props.imageURL}
                    alt={`תמונת קדימון לסרטון על ${props.Title || 'הפעילות'}`}
                />
                <div className="small_video_icon position-absolute" aria-hidden="true"></div>
            </button>
        ) : (
            <div className="d-flex justify-content-center align-items-center">
                <img 
                    className="bd-placeholder-img card-img-top rounded-0 py-1" 
                    width="100%"
                    src={props.imageURL}
                    alt={props.Title ? `תמונה של ${props.Title}` : 'תמונת פעילות'}
                />
            </div>
        )}

        {videoOpen && (
            <MahutiModal 
                closeModalWhenClickingBg={true} 
                setModalOpen={closeVideoModal}
                ref={modalRef}
            >
                <CustomFocusTrap active={videoOpen}>
                    <div 
                        className="video-modal-content" 
                        role="dialog" 
                        aria-modal="true" 
                        aria-labelledby="video-modal-title"
                        ref={modalContentRef}
                    >
                        <button
                            className="close-modal-button"
                            onClick={closeVideoModal}
                            aria-label="סגור סרטון"
                        >
                            ✕
                        </button>
                        <h2 id="video-modal-title" className="sr-only">
                            {`סרטון על ${props.Title || 'הפעילות'}`}
                        </h2>
                        {props.videoURL && (
                            <iframe 
                                ref={iframeRef}
                                className='video_iframe_ticket' 
                                src={props.videoURL} 
                                width='100%' 
                                height='100%' 
                                title={`סרטון על ${props.Title || 'הפעילות'}`}
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                                allowFullScreen={true}
                                tabIndex="0"
                            />
                        )}
                    </div>
                </CustomFocusTrap>
            </MahutiModal>
        )}

        <div className="p-0">
            <div className="text-mahuti py-1 mt-1">
                <div className="row">
                    <div className='col-6 d-flex mx-0 my-2 verticalLine'>
                        <div className="card-detail-time d-flex align-items-center">
                            <i className="clock me-2" role="img" aria-label="זמן פעילות"/>
                            <div className="d-flex flex-column">
                                <div className="text-right text fw-bold">
                                    {props.DurationTime ? `${props.DurationTime} דקות` : '--'}
                                </div>
                                {/* <div className="text-right text tiny-text">עם הפסקה קצרה</div> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-6 d-flex align-items-center m-0">
                        <div className="card-detail-price d-flex align-items-center">
                            <i className="shekel me-2" role="img" aria-label="מחיר כרטיס"></i>
                            <div className='d-flex flex-column'>
                                {props.isGenericEvent
                                    ? (props.price ? <div className="text-right fw-bold">
                                        {props.price.adults || '--'}  ₪ למבוגר
                                    </div> : '--')
                                    : <>
                                        {props.price ? <div className="text-right fw-bold">
                                            {props.price.underAge || '--'}  ₪ לילד
                                        </div> : '--'}
                                        {props.price ? <div className="text-right tiny-text">
                                            (מבוגר {props.price.adults || '--'} ₪)
                                        </div> : '--'}
                                      </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p className="description card-text py-1 my-1">{props.shortDescription__c || '--'}</p>
        </div>
        {props.disclaimer && props.disclaimer.length > 0 && <ul className="product_details_list alef card-body card-options py-1">
            {
                props.disclaimer.map((item) => {
                    return <li key={item.Id}>{item.Name}</li>
                })
            }
        </ul>}
        <div className="card-footer border-top-0 p-0 d-flex flex-column h-100 justify-content-end">
            <div className="d-flex justify-content-between" >
            <button type="button" 
                onClick={(e) => onClickPayHandle(e, 'sellingflow')} 
                className="almoni_tzar_bold btn card-button btn-primary w-100 rounded-0 border-0"
                aria-label={`לרכישת כרטיסים ל${props.Title || 'אירוע'}`}>
                לרכישה
            </button>
            </div>
            <div className="text-end mt-3">
            <button className="btn-link fw-bold pointer border-0 bg-transparent" 
                onClick={(e) => onClickPayHandle(e, 'productDetailsDisplay')}
                aria-label={`לפרטים נוספים על ${props.Title || 'אירוע'}`}
                type="button">
                לפרטים נוספים
            </button>
            </div>
        </div>
    </div>
}